import { scaleCorrectors } from '../../projection/styles/scale-correction.mjs';
import { transformProps } from '../../render/html/utils/transform.mjs';
function isForcedMotionValue(key, _ref) {
  let {
    layout,
    layoutId
  } = _ref;
  return transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}
export { isForcedMotionValue };